<script setup lang="ts">
import { GTMContentGroup } from '~/lib/models/gtm'
import { PickupStepType, PickupStep } from '~/lib/models/ui/modal-steps'

defineProps<{
  mobile: boolean
}>()

const emit = defineEmits(['set-step', 'close'])
const { t } = useLocale()
const { trackDeliveryOptions, trackOnWay, trackPageView, trackOnCloseModal } = useGTM()

const setStep = (s: PickupStepType) => {
  // delivery_options
  trackDeliveryOptions()
  emit('set-step', s)
}

const close = () => {
  emit('close')
  trackOnCloseModal()
}

const onMyWay = () => {
  // on_way
  trackOnWay()
  close()
}

onMounted(() => {
  trackPageView(
    {
      cg: GTMContentGroup.primary.ECOMMERCE,
      cg2: GTMContentGroup.secondary.TOO_FAR,
    },
    true
  )
})
</script>

<template>
  <main data-test="pickup-far-away">
    <ModalCenter :content-full="mobile" :add-close-button="false" :no-actions-class="true">
      <template #header>
        <div class="relative min-h-[4rem] w-full md:min-h-fit">
          <img
            v-if="mobile"
            class="h-8 cursor-pointer md:h-6"
            src="/images/icons/arrowLeft.svg"
            alt="close"
            @click="close"
          />
          <CloseIcon v-else width="16" height="16" @click="close" />
          <img
            src="/images/icons/pickUp.svg"
            alt="pickup marker"
            class="absolute bottom-0 left-1/2 hidden h-auto w-40 -translate-x-1/2 transform md:left-auto md:right-0 md:block md:transform-none"
          />
        </div>
      </template>
      <template #content>
        <template v-if="mobile">
          <section class="mt-auto p-4">
            <img class="mx-auto w-[70%]" src="/images/icons/pickUp.svg" alt="pickup marker" />
            <div class="my-10 text-center">
              <h2 class="mb-4 text-lg font-bold">{{ t('pickupMethods.farAway.title') }}</h2>
              <p class="text-sm">
                {{ t('pickupMethods.farAway.subtitle') }}
              </p>
            </div>
            <div class="flex flex-col gap-4">
              <McdButton
                is-primary
                class="py-3 text-sm"
                @on-click="setStep(PickupStep.AREA_SELECTION)"
              >
                {{ t('pickupMethods.farAway.actions.continue') }}
              </McdButton>
              <McdButton is-secondary class="py-3 text-sm" @on-click="onMyWay">
                {{ t('pickupMethods.farAway.actions.imOnWay') }}
              </McdButton>
            </div>
          </section>
        </template>
        <template v-else>
          <section class="mx-auto w-[80%]">
            <div class="my-5">
              <h2 class="mb-10 text-2xl font-bold">{{ t('pickupMethods.farAway.title') }}</h2>
              <p class="text-sm">
                {{ t('pickupMethods.farAway.subtitle') }}
              </p>
            </div>
            <div class="my-10 ml-auto flex w-[40%] flex-col items-end gap-4">
              <McdButton
                is-primary
                class="w-full px-10 py-3"
                @on-click="setStep(PickupStep.AREA_SELECTION)"
              >
                {{ t('pickupMethods.farAway.actions.continue') }}
              </McdButton>
              <McdButton is-secondary class="w-fit px-10 py-3" @on-click="onMyWay">
                {{ t('pickupMethods.farAway.actions.imOnWay') }}
              </McdButton>
            </div>
          </section>
        </template>
      </template>
    </ModalCenter>
  </main>
</template>
